import * as React from "react";

const SvgCalendar = (props) => (
  <svg
    className="calendar_svg__calendar"
    viewBox="0 0 531 456"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      d="M0 92.695h-110.601c-2.145 0-3.889-1.724-3.889-3.843V24.288H3.889v64.564c0 2.119-1.744 3.843-3.889 3.843M0-4.457h-12.29c-1.245 0-2.255.997-2.255 2.228C-14.545-.998-13.535 0-12.29 0H0c2.145 0 3.889 1.723 3.889 3.843v15.988H-114.49V3.843c0-2.12 1.744-3.843 3.889-3.843h12.289c1.246 0 2.255-.998 2.255-2.229s-1.009-2.228-2.255-2.228h-12.289c-4.631 0-8.399 3.723-8.399 8.3v85.009c0 4.576 3.768 8.3 8.399 8.3H0c4.632 0 8.4-3.724 8.4-8.3V3.843c0-4.577-3.768-8.3-8.4-8.3"
      style={{
        fillRule: "nonzero",
      }}
      transform="translate(495.834 50.202) scale(4.16667)"
    />
    <path
      d="M0 4.457h49.155c1.246 0 2.256-.998 2.256-2.229S50.401 0 49.155 0H0c-1.246 0-2.255.997-2.255 2.228 0 1.231 1.009 2.229 2.255 2.229"
      style={{
        fillRule: "nonzero",
      }}
      transform="translate(163.011 31.63) scale(4.16667)"
    />
    <path
      d="M0 19.638c1.245 0 2.255-.998 2.255-2.229V2.23C2.255.998 1.245 0 0 0c-1.246 0-2.255.998-2.255 2.23v15.179c0 1.231 1.009 2.229 2.255 2.229"
      style={{
        fillRule: "nonzero",
      }}
      transform="translate(123.54) scale(4.16667)"
    />
    <path
      d="M0 19.638c1.246 0 2.255-.998 2.255-2.229V2.23C2.255.998 1.246 0 0 0c-1.245 0-2.255.998-2.255 2.23v15.179c0 1.231 1.01 2.229 2.255 2.229"
      style={{
        fillRule: "nonzero",
      }}
      transform="translate(407.292) scale(4.16667)"
    />
    <path d="M111.803 175.33h43.204v42.692h-43.204zM174.207 175.33h43.205v42.692h-43.205zM236.612 175.33h43.204v42.692h-43.204zM299.02 175.33h43.204v42.692H299.02zM361.424 175.33h43.205v42.692h-43.205zM423.829 175.33h43.204v42.692h-43.204zM49.4 240.161h43.203v42.692H49.4zM111.803 240.161h43.204v42.692h-43.204zM174.207 240.161h43.205v42.692h-43.205zM236.612 240.161h43.204v42.692h-43.204zM299.02 240.161h43.204v42.692H299.02zM361.424 240.161h43.205v42.692h-43.205zM423.829 240.161h43.204v42.692h-43.204zM49.4 304.988h43.203v42.691H49.4zM111.803 304.988h43.204v42.691h-43.204zM174.207 304.988h43.205v42.691h-43.205zM236.612 304.988h43.204v42.691h-43.204zM299.02 304.988h43.204v42.691H299.02zM361.424 304.988h43.205v42.691h-43.205zM423.829 304.988h43.204v42.691h-43.204zM49.4 369.818h43.203v42.692H49.4zM111.803 369.818h43.204v42.692h-43.204zM174.207 369.818h43.205v42.692h-43.205zM236.612 369.818h43.204v42.692h-43.204zM299.02 369.818h43.204v42.692H299.02zM361.424 369.818h43.205v42.692h-43.205z" />
  </svg>
);

export default SvgCalendar;
